import { Component, ViewChild, Input } from '@angular/core';
import { DataView } from 'primeng/dataview';
import { EventRead } from '../shared/event-read.model';
import { TabsComponent, TabComponent } from '../../shared/widgets/tabs/index';
//import moment from 'moment-es6';
import { MomentService } from '../../shared/moment/moment.service';
import { NavigationService } from '../../shared/navigation/navigation.service';

import { EventV4ItemService } from '../shared/items/event-v4-item.service';
import { EventItemSummary } from '../shared/items/event-item-summary.model';
import { EventsV4Service } from '../shared/events-v4.service';
import { RegistrationManagementComponent } from 'src/app/events/registration/management/registration-management.component';
import { UtilService } from 'src/app/shared';

@Component({
  selector: 'wl-event-v4-dashboard',
  templateUrl: 'event-v4-dashboard.component.html',
  styleUrls: ['event-v4-dashboard.component.less'],
  providers: [EventV4ItemService],
    standalone: false
})
export class EventV4DashboardComponent {
  @ViewChild('eventItemDataGrid') public eventItemDataGrid: DataView;
  @Input() public event: EventRead;
  @Input() public registrationTab: TabComponent;
  @Input() public registrationManagementCtrl: RegistrationManagementComponent;
  @Input() public tabContainer: TabsComponent;

  public eventItems: Array<EventItemSummary>;
  public isSearching: boolean;
  public isFutureEvent: boolean;
  public isRegistrationOpen: boolean;
  public isUnderway: boolean;
  public isPastEvent: boolean;
  public amountInvoiced: number;
  public amountPaid: number;

  public loading: boolean = false;
  public loadError: string = '';

  public constructor(
    private _eventItemService: EventV4ItemService,
    private _eventService: EventsV4Service,
    private _navigationService: NavigationService,
    private _momentService: MomentService,
    private _utilService: UtilService
  ) {
    this.eventItems = new Array<EventItemSummary>();
    this.isSearching = false;
    this.event = new EventRead();
    this.isFutureEvent = false;
    this.isRegistrationOpen = false;
    this.isUnderway = false;
    this.isPastEvent = false;
    this.amountInvoiced = 0;
    this.amountPaid = 0;
  }

  public refresh(): void {
    this._eventService.deleteEventReadCache(this.event.EventId);
    this._eventService.getEventRead(this.event.EventId).then((e) => (this.event = e ? e : this.event));
    this.loadEventItems(true);
  }

  public loadEventItems = (refreshItemsFromDb: boolean = true): void => {
    if (!this.event || !this.event.EventId || this.event.EventId <= 0) {
      return;
    }

    this._eventItemService.deleteEventItemsCache(this.event.EventId);

    this.loading = true;
    this.loadError = '';
    this.amountPaid = 0;
    this.amountInvoiced = 0;

    if (refreshItemsFromDb) {
      this._eventItemService
        .getEventItems(this.event.EventId)
        .then((data: Array<any>) => {
          this.setItems(data);
        })
        .catch((error) => {
          this.loading = false;
          this.loadError = this._utilService.extractErrorMessage(error);
        });
    } else {
      this.setItems(this.event.Items);
    }
  };

  private setItems(items: EventItemSummary[]) {
    this.loading = false;

    this.eventItems = items;

    for (let item of this.eventItems) {
      this.amountInvoiced = this.amountInvoiced + item.AmountInvoiced;
      this.amountPaid = this.amountPaid + item.AmountPaid;
    }

    this.setEventStatus();
  }

  public goToRegistrationManagement(id: number): void {
    this.tabContainer.select(this.registrationTab);
    this.registrationManagementCtrl.searchEventItemFromDashboard(id);
  }

  public viewEventReport = (): void => {
    this._eventService
      .getSignUpsAndAttendenceReportUrl(this.event ? this.event.EventId : 0)
      .then((url) => this._navigationService.popupSafeNavigate(url));
  };

  public printNameBadges = (): void => {
    this._eventService
      .getNameBadgeReportUrl(this.event ? this.event.EventId : 0)
      .then((url) => this._navigationService.popupSafeNavigate(url));
  };

  public setEventStatus = (): void => {
    const currentDate: Date = this._momentService.getMoment().startOf('day').toDate();
    const eventStartDate: Date = this._momentService
      .getMomentByDate(this.event ? this.event.StartDate : new Date())
      .startOf('day')
      .toDate();
    const eventEndDate: Date = this._momentService
      .getMomentByDate(this.event ? this.event.EndDate : new Date())
      .startOf('day')
      .toDate();

    let allItemsInFuture: boolean = !this.eventItems.length
      ? true
      : this.eventItems.every(
          (item) =>
            !item.IsPublic ||
            (currentDate < this._momentService.getMomentByDate(item.StartDate).startOf('day').toDate() &&
              currentDate < this._momentService.getMomentByDate(item.EndDate).startOf('day').toDate())
        );
    let anyItemOpenRegistration: boolean = this.eventItems.some(
      (item) =>
        item.IsPublic &&
        currentDate >= this._momentService.getMomentByDate(item.StartDate).startOf('day').toDate() &&
        currentDate <= this._momentService.getMomentByDate(item.EndDate).startOf('day').toDate()
    );

    // start with no event status
    this.isRegistrationOpen = false;
    this.isFutureEvent = false;
    this.isPastEvent = false;
    this.isUnderway = false;

    if (currentDate < eventStartDate && (allItemsInFuture || this.event.DisableRegistration)) {
      this.isRegistrationOpen = false;
      this.isFutureEvent = true;
      this.isPastEvent = false;
      this.isUnderway = false;
      //console.error("isFutureEvent");
    }
    if (currentDate > eventEndDate) {
      this.isRegistrationOpen = false;
      this.isFutureEvent = false;
      this.isPastEvent = true;
      this.isUnderway = false;
      //console.error("isPastEvent");
    }
    if (currentDate <= eventEndDate && currentDate >= eventStartDate) {
      this.isRegistrationOpen = false;
      this.isFutureEvent = false;
      this.isPastEvent = false;
      this.isUnderway = true;
      //console.error("isUnderway");
    }
    if (this.event.DisableRegistration == false && anyItemOpenRegistration && this.isPastEvent == false && this.isFutureEvent == false) {
      this.isRegistrationOpen = true;
      this.isFutureEvent = false;
      this.isPastEvent = false;
      this.isUnderway = false;
      //console.error("isRegistrationOpen");
    }
  };
}
